module.exports = __webpack_public_path__ + "static/media/house-3.64d4f650.jpg";